import { useMediaQuery } from 'react-responsive'

export const API_BASE_URL = 'https://images.dentalstores.in/api/admin'
export const BASE_URL = 'https://images.dentalstores.in'
export const CSRF = 'https://images.dentalstores.in/sanctum/csrf-cookie'
export const API_KEY_ID= 'dsin_live_UCaGUiqyAde5VK'
export const API_KEY_SECRET= '9bdff78d-6efe-4311-ba2b-60f380942cd5'

export const useDeviceType = () => {
    const isDesktop = useMediaQuery({ minWidth: 1025 });
    const isTablet = useMediaQuery({ maxWidth: 1024 });
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return { isDesktop, isTablet, isMobile };
};

export const IMG = {
    logo: require('../assets/imgs/logo.svg').default,
    logoLight: require('../assets/imgs/logo-light.svg').default,
    authblur: require('../assets/imgs/authblur.png'),
    sidebarart: require('../assets/imgs/sidebarart.png'),
    DP: require('../assets/imgs/default-profile.png'),
}

export const Icons = {
    eyeFrame: require('../assets/imgs/icons/eye-frame.svg').default,
    eyeSlash: require('../assets/imgs/icons/eye-slash.svg').default,
    calendar: require('../assets/imgs/icons/calendar.svg').default,
    sync: require('../assets/imgs/icons/SyncOutlined.svg').default,
    mapcircle: require('../assets/imgs/icons/mapcircle.svg').default,
    oprovided: require('../assets/imgs/icons/oprovided.svg').default,
    odispatched: require('../assets/imgs/icons/odispatched.svg').default,
    orders: require('../assets/imgs/icons/orders.svg').default,
    acart: require('../assets/imgs/icons/acart.svg').default,
    download: require('../assets/imgs/icons/download.svg').default,
}